import type { FC } from 'react';
import { FacebookSheets } from 'features/cabinet';
import { CabinetTitlePage } from 'components/layout';
import { Guard, usePermissionGuard } from 'features/login';
import { LinkButton } from 'components/common';
import { Add } from '@mui/icons-material';

const FacebookSheetsPage: FC = () => {
  const { accessToViewFacebookpage, accessToAddFacebookpage } = usePermissionGuard();

  return (
    <Guard hasAccess={accessToViewFacebookpage} fallback>
      <CabinetTitlePage
        title={'Facebook Pages'}
        endAdornment={
          <LinkButton
            to={'/cabinet/facebook/facebook-pages/add'}
            title={'Add page'}
            startIcon={<Add />}
            disabled={!accessToAddFacebookpage}
          />
        }
      />
      <FacebookSheets />
    </Guard>);
};

export default FacebookSheetsPage;
